import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header.jsx";
import Sidebar from "../../layouts/Sidebar.jsx";
import { Table } from "antd";
// import {itemRender} from "../../_components/paginationfunction.jsx";
// import { Link } from "react-router-dom";
// import axios from "axios";
import * as XLSX from "xlsx";
import AddEmployee from "./AddEmployee.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import EditEmployee from "./EditEmployee.jsx";
import EmployeeView from "./EmployeeView.jsx";
import ApiService from "../../service/httpService.js";

const Employee_List = () => {
  //state management
  const [datasource, setDataSource] = useState([]);
  const [isLoding, setisLoding] = useState(false);
  const [Data, setData] = useState([]);
  const [ViewData, setViewData] = useState({});
  const [menu, setMenu] = useState(false);
  const [EditData, setEditData] = useState({});
  const [LocationData, setLocationData] = useState([]);

  //fetching employee datas
  const fetchEmployees = async () => {
    setisLoding(true);
    try {
      const res = await ApiService.getPublic(
        `get_data.php?table=employee&asign_field=id&asign_value=DESC&authToken=`
      );
      console.log("employee", res);
      setDataSource(res);
      setData(res);
      setisLoding(false);
    } catch (err) {
      console.log("error on fetchEmployees", err);
      setisLoding(false);
    }
  };

  const location = async () => {
    try {
      const res = await ApiService.getPublic(
        `get_data.php?table=location&authToken=`
      );
      console.log("Location 1", res);
      setLocationData(res);
    } catch (err) {
      console.log("error on fetchEmployees", err);
      console.log(LocationData);
    }
  };

  useEffect(() => {
    fetchEmployees();
    location();
  }, []);

  const handleEditClick = (record) => {
    setEditData(record);
    console.log("record", record);
  };

  function reorderAndFilterKeys(data, keyOrder) {
    return data.map((obj) => {
      const newObj = {};
      keyOrder.forEach((key) => {
        if (key in obj) {
          newObj[key] = obj[key];
        }
      });
      return newObj;
    });
  }

  const HandleView = (record) => {
    setViewData(record);
    console.log(record);
  };

  const HandleExport = (data) => {
    // Step 1: Convert JSON data to worksheet
    const worksheet = XLSX.utils.json_to_sheet(
      reorderAndFilterKeys(data, [
        "name",
        "mobile",
        "date_time",
        "salary",
        "user_type",
        "status",
        "blood_group",
        "dob",
        "emergency_con_number",
        "emergency_con_person",
        "emp_type",
      ])
    );

    // Step 2: Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const now = new Date();

    const pad = (n) => n.toString().padStart(2, "0");

    const formattedDate = `${pad(now.getDate())}-${pad(
      now.getMonth() + 1
    )}-${now.getFullYear()}`;
    const formattedTime = `${pad(now.getHours())}:${pad(
      now.getMinutes()
    )}:${pad(now.getSeconds())}`;

    // Step 3: Write the workbook and trigger download
    XLSX.writeFile(
      workbook,
      `Employee_Data_${formattedDate}_${formattedTime}.xlsx`
    );
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const HandleReferesh = () => {
    fetchEmployees();
  };

  const handleInput = (event) => {
    const query = event.target.value?.toLowerCase() ?? "";

    if (!query) {
      setDataSource(Data); // reset if input is empty
      return;
    }

    const result = Data.filter(
      (item) =>
        item.user_type
          .toString()
          .toLowerCase()
          .includes(query) ||
        item.mobile
          .toString()
          .toLowerCase()
          .includes(query) ||
        item.id
          .toString()
          .toLowerCase()
          .includes(query) ||
        item.name
          .toString()
          .toLowerCase()
          .includes(query)
    );

    setDataSource(result);
  };

  function getLocation(id) {
    const match = LocationData?.find((item) => item.id === id) ;
    if (match) {
      return match;
    } else {
      return "0";
    }
  }

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      // sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "User Type",
      dataIndex: "user_type",
      sorter: (a, b) => a.user_type.localeCompare(b.user_type),
    },
    {
      title: "Employee Status",
      dataIndex: "status",
      render: (status) => (
        <div>
          {status == 1 && (
            <span className="badge bg-success-light">
              <i className="fe fe-check me-1"></i>Active
            </span>
          )}
          {status == 0 && (
            <span className="badge bg-danger-light">
              <i className="fe fe-x me-1"></i>Inactive
            </span>
          )}
        </div>
      ),
      sorter: (a, b) => a.status - b.status,
    },

    {
      title: "Location Status",
      dataIndex: "location",
      render: (text) => (
        <div>
          {getLocation(text).status == 1 && (
            <span className="badge bg-success-light">
              <i className="fe fe-check me-1"></i>
              {getLocation(text).name}
            </span>
          )}
          {getLocation(text).status == 0 && (
            <span className="badge bg-danger-light">
              <i className="fe fe-x me-1"></i>
              {getLocation(text).name}
            </span>
          )}
        </div>
      ),
      // sorter: (a, b) =>a.statu.localeCompare(b.statu)
    },
    {
      title: "Action",
      dataIndex: "Action",
      render: (text, record) => (
        <div className="table-invoice d-flex align-items-center">
          <div className="dropdown dropdown-action">
            <a
              className="btn-action-icon"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={(e) => e.preventDefault()}
            >
              <i className="fas fa-ellipsis-v" />
            </a>
            <div className="dropdown-menu dropdown-menu-end">
              <ul className="list-unstyled mb-0">
                <li key={`view-${record.id}`}>
                  <a
                    className="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#employee-view"
                    onClick={() => {
                      HandleView(record);
                    }}
                  >
                    <i className="far fa-eye me-2"></i> View
                  </a>
                </li>
                <li key={`edit-${record.id}`}>
                  <a
                    className="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#Edit-employee"
                    onClick={() => {
                      handleEditClick(record);
                    }}
                  >
                    <i className="fe fe-edit me-2" /> Edit
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="content-page-header flex-column gap-3 ">
                <h5>Employee Master</h5>
                <div className="page-content">
                  <div className="list-btn">
                    <ul className="filter-list d-flex justify-content-center">
                      <div className="d-flex flex-column flex-md-row gap-md-0">
                        <li>
                          {/* Search */}
                          <form className="m-0">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search here"
                              onChange={handleInput}
                            />
                          </form>
                          {/* /Search */}
                        </li>

                        {/* referesh function */}
                        <li>
                          <a
                            className="btn-filters p-2"
                            data-bs-toggle="tooltip"
                            data-bs-placement="bottom"
                            title="Refresh"
                            onClick={HandleReferesh}
                          >
                            <span>
                              <i className="fe fe-refresh-ccw pe-1" />
                            </span>
                            Refresh
                          </a>
                        </li>
                      </div>

                      <div className="d-flex gap-2 ">
                        <li>
                          <button
                            className="d-flex align-items-center download-item btn btn-filters"
                            onClick={(e) => {
                              e.preventDefault();
                              HandleExport(Data);
                            }}
                          >
                            <i className="far fa-file-text me-2" />
                            Export
                          </button>
                        </li>

                        <li>
                          <a
                            className="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#add_companies"
                          >
                            <i
                              className="fa fa-plus-circle me-2"
                              aria-hidden="true"
                            />
                            Add Employee
                          </a>
                        </li>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* /Page line */}
            <div className="super-admin-list-head"></div>
            {isLoding ? (
              <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status" />
              </div>
            ) : (
              <div className="row">
                <div className="col-sm-12 ">
                  <div className="card-table">
                    <div className="card-body">
                      <div className="table-responsive">
                        <Table
                          style={{ background: "transparent" }}
                          pagination={{
                            total: datasource.length,
                            showSizeChanger: true,
                            // onShowSizeChange: onShowSizeChange,
                            // itemRender: itemRender,
                          }}
                          rowKey="id"
                          columns={columns}
                          dataSource={datasource}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <AddEmployee fetchEmployees={fetchEmployees} Data={Data} />
      <EditEmployee
        Emp_data={EditData}
        fetchEmployees={fetchEmployees}
        Data={Data}
      />
      <EmployeeView Emp_data={ViewData} />
    </div>
  );
};

export default Employee_List;
